(function () {
    angular.module('tmx-app').directive('tmxDynamicGrid', tmxDynamicGrid);
    var exists;
    var isFunction;
    var showCustomToast;
    function tmxDynamicGrid() {
        var directive = {};
        directive.scope = {
            name: '@',
            label: '@',
            columns: '@',
            model: '@',
            aggregates: '@',
            form: '=',
            required: '@',
            onChange: '&',
            data: '=',//should be a kendo observable array,
            dynamicField: '=',// only for dynamic form, ignore it and functions in which it occurs
            disabled: '=',
            dynamicShow: '=',// only for dynamic form, ignore it and functions in which it occurs
            helpText: '@',
            hidePaging: '=',
            onGridDataFetch: '&',
            field: '@'
        };
        //directive.replace=true;
        directive.restrict = 'E';
        directive.templateUrl = 'common/directives/tmxdynamicgrid/tmxdynamicgrid.html';
        directive.controller = ["$scope", "tmxUtility", "lookupService", "dynamicFormService", "ToastService", gridCtrl];
        directive.controllerAs = "gridCtrl";
        return directive;
    }

    function gridCtrl($scope, tmxUtility, lookupService, dynamicFormService, ToastService) {
        exists = tmxUtility.exists;
        isFunction = tmxUtility.isFunction;
        showCustomToast = ToastService.showCustomToast;
        $scope.lookups = lookupService.getReturnObject().lookups;
        if (dynamicFormService.applicationData && dynamicFormService.applicationData.TmxCustomerMaster && dynamicFormService.applicationData.TmxCustomerMaster[0]) {
            $scope.cnic = dynamicFormService.applicationData.TmxCustomerMaster[0].NationalIdentifierValue;
            $scope.oldcnic = dynamicFormService.applicationData.TmxCustomerMaster[0].OldNationalIdentifierValue;
        }
        $scope.columns = JSON.parse($scope.columns);
        decorateColumns($scope.columns);
        decorateDropdowns($scope.columns, $scope.lookups,lookupService);
        $scope.aggregates = JSON.parse($scope.aggregates);
        $scope.model = JSON.parse($scope.model);
        decorateModel($scope.model);
        setDefaultIdToModel($scope.model);
        Object.keys($scope.model.fields).forEach(function (key) { setDefaultForDropdown(key, $scope.model.fields); });
        $scope.gridOptions = makeProperGridOptions($scope, $scope.columns, $scope.data, $scope.label, $scope.aggregates, $scope.model, $scope.dynamicField, $scope.hidePaging);
    }

    function customRequired(input, attrname, included) {
        var fname;
        if (!exists(input.attr("name"))) {
            if (exists($(input).attr('data-bind'))) {
                fname = $(input).attr('data-bind');
                fname = fname.substr(fname.indexOf(":") + 1);
                input.attr("name", fname);//set name-- to fix kendo's bug
            }
            else {
                return true;
            }
        }
        else {
            fname = input.attr("name");
        }
        if (included.has(fname) && (input.val() == "" || input.val() == "0")) {
            input.attr("data-" + attrname + "-msg", fname + " is required!");
            return false;
        }
        return true;
    }

    function decorateColumns(columns) {
        function decorateEachColumn(column) {
            if (column.type == "numeric") {
                column.type = "number";
            }
            if (exists(column.expression)) {
                var columnNames = Object.keys(column.variables).map(key => column.variables[key]);
                columnNames.forEach(col => {
                    column.expression = column.expression.replace(new RegExp(col, 'g'), `row['${col}']`) // Global regex to match all occurences in formula
                })
                column.template = new Function('row', column.expression);
            }

        }
        columns.forEach(decorateEachColumn);
    }

    function decorateModel(model) {
        var fields = Object.keys(model.fields);
        var included = new Set();
        function decorateField(fname) {
            var field = model.fields[fname];

            if(field.validation){
                if(field.validation.max){
                    if(field.type =='text' || field.type == 'numeric'){
                        field.validation.Maxlength = field.validation.max;
                        delete field.validation.max;
                    } 
                    else if (field.type =='number'){
                        // No need to do anything as the numbers are already transformed to required min and max value
                    }
                    
                }
                if(field.validation.min){
                    if(field.type =='text'){
                        field.validation.MinLength = field.validation.min;
                        delete field.validation.min;
                    } 
                    else if (field.type =='number'){
                        // No need to do anything as the numbers are already transformed to required min and max value
                    }
                }
            }               
            if (exists(field, "validation.required") && field.validation.required) {
                included.add(fname);
                if (field.type == "select") {
                    field.type = "number";
                }
                field.validation.customrequired = function (input) { return customRequired(input, "customrequired", included); }
                delete field.validation.required;
            }

            if (field.type == "numeric" || field.type == "select") { // Set numeric and select to number after the field length validations has been set this condition must be check in the end
                field.type = "number";
            }      
            
        }
        fields.forEach(decorateField);
    }


    function decorateDropdowns(columns, lookups,lookupService) {
        function decorateColumnIfDropdown(column) {

            if (exists(column.lookupType)) {

                // function for editor
                function dropDownEditor(container, options) {
                    //Converts Visible Values of all Options of Dropdown to TitleCase
                    for (var i = 0; i < options.values.length; i++) {
                        options.values[i].VisibleValue = options.values[i].VisibleValue.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
                    }
                    var templ = '<input data-bind="value:' + options.field + '"/>';
                    $(templ).appendTo(container).kendoDropDownList({
                        dataTextField: "VisibleValue",
                        dataValueField: "LookupId",
                        suggest: true,
                        dataSource: {
                            data: options.values
                        },
                        animation: false,
                        change: function (arg) {
                            var grid = arg.sender.element.closest(".k-grid").data("kendoGrid");
                            var row = arg.sender.element.closest("tr");
                            var dataRow = grid.dataItem(row);
                        
                            grid.options.dataSource.options.data.forEach(dataItem => {     
                                if(dataItem==dataRow){                            
                                    columns.forEach(columnItem => {
                                        if (!dataRow[columnItem.field] && (columnItem.type == 'number' || columnItem.type == 'select')) {
                                            dataRow[columnItem.field] = 0; //to-do: replace by default value
                                        }
                                        if (exists(columnItem.disableTemplate)) {

                                            var fieldTemplate = columnItem.disableTemplate;
                                            if (isFunction(fieldTemplate) || !exists(columnItem.disableVariables)) {
                                                return;
                                            }
                                            let variables = Object.keys(columnItem.disableVariables).map(key => columnItem.disableVariables[key]);
                                            fieldTemplate = fieldTemplate.replace(/#=|#/g, '').trim()

                                            variables.forEach(x => {
                                                fieldTemplate = fieldTemplate.replace(new RegExp(x, 'g'), "dataItem['" + x + "']");
                                            });

                                            if (!eval(fieldTemplate)) {
                                                var editable = $('input[name=' + columnItem.field + ']')
                                                editable.attr('class', 'k-input k-textbox');
                                                editable.attr("disabled", false);
                                            }
                                            else {
                                                var notEditable = $('input[name=' + columnItem.field + ']')
                                                notEditable.attr('class', 'k-input k-textbox not-editable');
                                                notEditable.attr("disabled", true);
                                            }
                                        }
                                        if(exists(columnItem.requiredTemplate)) {
                                            var fieldReqTemplate = columnItem.requiredTemplate;
                                            if (isFunction(fieldTemplate) || !exists(columnItem.requiredVariables)) {
                                                return;
                                            }
                                            let variables = Object.keys(columnItem.requiredVariables).map(key => columnItem.requiredVariables[key]);
                                            fieldReqTemplate = fieldReqTemplate.replace(/#=|#/g, '').trim()

                                            variables.forEach(x => {
                                                fieldReqTemplate = fieldReqTemplate.replace(new RegExp(x, 'g'), "dataItem['" + x + "']");
                                            });

                                            if (eval(fieldReqTemplate)) {
                                                var required = $('input[name=' + columnItem.field + ']')
                                                // required.attr('class', 'k-input k-textbox');
                                                required.attr("required", true);
                                            }
                                            else {
                                                var notRequired = $('input[name=' + columnItem.field + ']')
                                                // notRequired.attr('class', 'k-input k-textbox not-editable');
                                                notRequired.attr("required", false);
                                            }
                                        }
                                        if(exists(columnItem.lookupType)){                                            
                                            if(columnItem.lookupType.indexOf("groupLookupBy") > -1){

                                                var parentColumnId=columnItem.options.variables[0].substring(2);
                                                var parentColumn=columns.filter(x=>x.tfId==parentColumnId)[0].title;
                                                var parentId=dataRow[parentColumn];
                                                if(options.field==parentColumn){
                                                if(parentId>0 && dataRow[columnItem.title]==0){
                                                
                                                    var startPoint=columnItem.lookupType.indexOf("groupLookupBy")+15;
                                                    var endPoint=columnItem.lookupType.indexOf(",")-1;

                                                    var lookupType= columnItem.options.basicFormula.substring(startPoint, endPoint);
                                                                                                                                                                                                                                        
                                                    var response = lookupService.getByTypeAndParentLocal(lookupType, parentId);  
                                                
                                                    columnItem.values = response.sort(function (lkp1, lkp2) {
                                                        if (lkp1.VisibleValue < lkp2.VisibleValue) return -1;
                                                        if (lkp1.VisibleValue > lkp2.VisibleValue) return 1;
                                                        if (lkp1.VisibleValue == lkp2.VisibleValue) return 0;
                                                    });  
                                               
                                                    var dropdowm = $('[data-container-for='+columnItem.field+']');    
                                                    dropdowm.empty();                                        
                                                    
                                                    for (var i = 0; i < columnItem.values.length; i++) {
                                                        columnItem.values[i].VisibleValue = columnItem.values[i].VisibleValue.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
                                                    }                                                    
                                                                                                
                                                    var templ = '<input data-bind="value:' + columnItem.field + '"/>';
                                                                                                      
                                                    $(templ).appendTo(dropdowm).kendoDropDownList({
                                                        dataTextField: "VisibleValue",
                                                        dataValueField: "LookupId",
                                                        suggest: true,
                                                        dataSource: {
                                                            data: columnItem.values
                                                        }});         
                                                }   
                                            }                                                                                        
                                            }
                                        }                                        
                                    });
                                }
                            });                                                                                                   
                        }
                    });
                }

                //function for visible template
                function dropDownTemplate(row) {
                    if(!row[column.field] && column.defaultValue) {
                        //set default value if nothing selected
                        row[column.field] = column.defaultValue;

                    }
                    var selectedHiddenValue = row[column.field];// get current selected hidden value
                    if (angular.isObject(selectedHiddenValue)) {
                        row[column.field] = row[column.field].LookupId;
                        selectedHiddenValue = selectedHiddenValue.LookupId;
                    }
                    function onHidden(item) {
                        return item.LookupId == selectedHiddenValue;
                    }
                    var selectedItem = column.values.filter(onHidden);//from list of lookups filter the one with same hidden value
                    if (exists(selectedItem) && selectedItem.length > 0) {//If found a match
                        return selectedItem[0].VisibleValue.toString();//print it's visible value
                    }
                    else {
                        return "";//else ignore
                    }
                }

                //rest of stuff for dropdown
                column.editor = dropDownEditor;

                //set lookup values for dropdown
                if(column.lookupType.indexOf("groupLookupBy")< 0){
                    if(exists(lookups[column.lookupType])){
                column.values = lookups[column.lookupType].sort(function (lkp1, lkp2) {
                    if (lkp1.VisibleValue < lkp2.VisibleValue) return -1;
                    if (lkp1.VisibleValue > lkp2.VisibleValue) return 1;
                    if (lkp1.VisibleValue == lkp2.VisibleValue) return 0;
                });
                    }
                }
                else{
                    column.values=[];
                }

                column.template = dropDownTemplate;
            }
        }
        columns.forEach(decorateColumnIfDropdown);
    }

    function setColumnValues(fields, grid, scope) {
        fields.forEach(function (field) { initAggregates(field, grid, scope) });
    }

    function initAggregates(field, grid, scope) {
        //aggregates to cover for field
        var ret = { count: 0 };
        var rows = grid.dataSource.data();//returns all rows in datasource
        rows.forEach(function (row, index) {
            var item = isNaN(parseFloat(row[field.name])) ? 0 : parseFloat(row[field.name]);
            if (!isNaN(item)) {
                if (index == 0) {//initialize with first row
                    ret.average = undefined,
                        ret.max = item,
                        ret.min = item,
                        ret.sum = 0;
                }
                if (item > ret.max) ret.max = item;//calculates max
                if (item < ret.min) ret.min = item;//calculates min
                ret.sum += item;
            }
            ret.count++;
        });
        ret.average = ret.sum / ret.count;
        if (angular.isFunction(scope.onChange())) {
            scope.onChange()(ret, { dynamicField: field });
        }
        field.value = ret;
        return field.value;
    }
    function getDataForGrid(data, model) {
        data.forEach(dataItem => {
            Object.keys(model.fields).forEach(propertyName=> {
                if(!dataItem[propertyName] && model.fields[propertyName].type == "number") {
                    dataItem[propertyName] = 0;
                }
            });
        });
        return data;
    }
    function makeProperGridOptions($scope, cols, data, label, aggregates, model, parentField, hidePaging, onGridReady) {
        var gridReady = false;
        var dataSource = new kendo.data.DataSource({
            data: getDataForGrid(data, model),
            schema: {
                model: model
            },
            aggregate: aggregates,
            pageSize: hidePaging ? undefined : 10
        });
        var mainGridOptions = {
            dataSource: dataSource,
            resizable: false,
            toolbar: [
                { template: "<label class='checkbox-label'>" + label + ":</label>" }
            ],
            scrollable: false,
            sortable: true,
            pageable: hidePaging ? false : true,
            /*selectable: "multiple cell",*/
            editable: true,
            edit: function(e) {
                var grid = e.sender.element.closest(".k-grid").data("kendoGrid");  
                var editableGrids = e.sender.element.closest(".k-grid").find(".k-grid-edit-row");
                if(editableGrids.length > 1) {
                    grid.refresh();
                    return;
                }
                else {        
                    var dataRow = e.model;
                    grid.options.dataSource.options.data.forEach(dataItem => {
                        if (dataItem == dataRow) {
                            cols.forEach(columnItem => {
                                if (!dataRow[columnItem.field] && (columnItem.type == 'number' || columnItem.type == 'select')) {
                                    dataRow[columnItem.field] = 0; //to-do: replace by default value
                                }
                                if (exists(columnItem.disableTemplate)) {

                                    var fieldTemplate = columnItem.disableTemplate;
                                    if (isFunction(fieldTemplate) || !exists(columnItem.disableVariables)) {
                                        return;
                                    }
                                    let variables = Object.keys(columnItem.disableVariables).map(key => columnItem.disableVariables[key]);
                                    fieldTemplate = fieldTemplate.replace(/#=|#/g, '').trim()

                                    variables.forEach(x => {
                                        fieldTemplate = fieldTemplate.replace(new RegExp(x, 'g'), "dataItem['" + x + "']");
                                    });

                                    if (!eval(fieldTemplate)) {
                                        var editable = $('input[name=' + columnItem.field + ']')
                                        editable.attr('class', 'k-input k-textbox editable');
                                        editable.attr("disabled", false);
                                    }
                                    else {
                                        var notEditable = $('input[name=' + columnItem.field + ']')
                                        notEditable.attr('class', 'k-input k-textbox not-editable');
                                        notEditable.attr("disabled", true);
                                    }
                                }
                                if (exists(columnItem.requiredTemplate)) {
                                    var fieldReqTemplate = columnItem.requiredTemplate;
                                    if (isFunction(fieldTemplate) || !exists(columnItem.requiredVariables)) {
                                        return;
                                    }
                                    let variables = Object.keys(columnItem.requiredVariables).map(key => columnItem.requiredVariables[key]);
                                    fieldReqTemplate = fieldReqTemplate.replace(/#=|#/g, '').trim()

                                    variables.forEach(x => {
                                        fieldReqTemplate = fieldReqTemplate.replace(new RegExp(x, 'g'), "dataItem['" + x + "']");
                                    });

                                    if (eval(fieldReqTemplate)) {
                                        var required = $('input[name=' + columnItem.field + ']')
                                        // required.attr('class', 'k-input k-textbox');
                                        required.attr("required", true);
                                    }
                                    else {
                                        var notRequired = $('input[name=' + columnItem.field + ']')
                                        // notRequired.attr('class', 'k-input k-textbox not-editable');
                                        notRequired.attr("required", false);
                                    }
                                }

                            });
                        }
                    });
                }
            },
            cancel: function(e) {
                var grid = e.sender.element.closest(".k-grid").data("kendoGrid");  
                grid.dataSource.read();
            },
            change: onChange,
            dataBound: onDataBound,
            dataBinding: onDataBinding,
            save: function (e) {
                var grid = this;                
                // var notAllowedTypes = ["select","treeview","date","timestamp","text"];					
                // var allowedTypes = ["number", "amount", "numeric", "rangenumber"];
                grid.dataSource.options.data.forEach(dataItem => {
                    grid.columns.forEach(columnItem => {
                        if (exists(columnItem.template) ) {
                            //var fields = columnItem.template;
                            if(!dataItem[columnItem.field] && (columnItem.type == "select" || columnItem.type == "number")){
                                //set default value if null
                                dataItem[columnItem.field] = 0;
                            }

                            var fieldTemplate = columnItem.template; //"";
                            if (isFunction(fieldTemplate) || !exists(columnItem.variables)) { // No need to do it on function template, it will calculate automatically
                                return;
                            }
                            let variables = Object.keys(columnItem.variables).map(key => columnItem.variables[key]);
                            fieldTemplate = fieldTemplate.replace(/#=|#/g, '').trim()

                            variables.forEach(x => {
                                fieldTemplate = fieldTemplate.replace(new RegExp(x, 'g'), "dataItem['" + x + "']");
                            });
                            dataItem[columnItem.field] = eval(fieldTemplate);
                        }

                    })
                })
                grid.dataSource.sync();
            },
            columns: cols
        };
        if (!$scope.disabled) {
            if (!$scope.dynamicField.form_name.includes('TmxLoanApplicationDeviationView') && !(exists($scope.dynamicField.editState) && $scope.dynamicField.editState == '2'))
                mainGridOptions.toolbar.push({ name: "create" });
            mainGridOptions.editable = {
                mode: "inline", // mode can be incell/inline/popup with Q1 '12 Beta Release of Kendo UI
                confirmation: false // disable the annoying confirmation message for destroy command
            };
            if(exists($scope.dynamicField.editState) && ($scope.dynamicField.editState == '2' || $scope.dynamicField.editState == '3')) { //disable deletion
                mainGridOptions.columns[mainGridOptions.columns.length - 1].command.pop('destroy');
            }
        }
        else {
            mainGridOptions.editable = false;
            delete mainGridOptions.columns[mainGridOptions.columns.length - 1]; // removing last column edit and delete button
        }

        if (mainGridOptions.toolbar && mainGridOptions.editable) {
            if (!$scope.dynamicField.form_name.includes('TmxLoanApplicationDeviationView')) {
                mainGridOptions.toolbar[0].template += '<md-button flex="none" class="grid-refresh-button" ng-click="refresh()">'
                    + '<md-icon class="tmx-button md-accent material-icons">refresh</md-icon>Refresh'
                    + '</md-button>';

                if (exists(JSON.parse($scope.field).formula) && JSON.parse($scope.field).formula.expression.includes("copyData")) {
                    mainGridOptions.toolbar[0].template += '<md-button flex="none" class="grid-refresh-button" ng-click="gridDataFetch()">'
                        + '<md-icon class="tmx-button md-accent material-icons">file_copy</md-icon>Fetch Data'
                        + '</md-button>';
                }
            }
        }


        $scope.gridDataFetch = function () {
            var source = JSON.parse($scope.field).formula.variables[0];
            var destination = JSON.parse($scope.field).tableObj.tname;
            $scope.onGridDataFetch({ src: source, des: destination });
        }


        if (parentField.form_name.includes('TmxECIBDetail')) {// for ecIB grid only
            if (mainGridOptions.toolbar) {
                mainGridOptions.toolbar[0].template += '<md-menu flex=none class=menu-list-item><md-button class="menu-list-item-grid md-fab md-primary" ng-click=$mdOpenMenu()><md-icon class=menu-list-item material-icons padding-right-6>save_alt</md-icon></md-button><md-menu-content width=2><md-menu-item><md-button aria-label=del class=tmxMin ng-click=downloadPdf()><md-icon class=md-accent material-icons menu-list-item>open_in_new</md-icon>New CNIC Report</md-button></md-menu-item><md-menu-item><md-button aria-label=del class=tmxMin ng-click=downloadoldPdf()><md-icon class=md-accent material-icons menu-list-item>open_in_new</md-icon>Old CNIC Report </md-button></md-menu-item></md-menu-content></md-menu>'
            }
        }

        $scope.downloadPdf = function () {
            //if(this.data.length>0)
            window.open(ENV.ecibURL + this.cnic + '.pdf', '_blank');
        }
        $scope.downloadoldPdf = function () {
            if (this.oldcnic)
                window.open(ENV.ecibURL + this.oldcnic + '.pdf', '_blank');
            else {
                showCustomToast('error', 'Old CNIC not found');
            }
        }

        function onDataBound(arg) {
            if (!gridReady) {//means this is the first time the function has run
                if (exists(onGridReady))//if there is some thing to do on grid ready
                    onGridReady(arg.sender);
                var grid = arg.sender.element.closest(".k-grid").data("kendoGrid");
                grid.options.dataSource.options.data.forEach(dataItem => {
                    cols.forEach(columnItem => {
                        if (!dataItem[columnItem.field] && (columnItem.type == 'number' || columnItem.type == 'select')) {
                            dataItem[columnItem.field] = 0; //to-do: replace by default value
                        }
                    });
                });
                gridReady = true;
                grid.dataSource.sync();
            }
            setColumnValues(parentField.gridOptions.columns, arg.sender, $scope);
            if (angular.isFunction($scope.onChange())) {
                $scope.onChange()($scope.data, $scope);
            }
        }

        function onDataBinding(arg) {
        }

        function onChange(arg) {
            var selected = $.map(this.select(), function (item) {
                return $(item).text();
            });
            //setColumnValues(parentField.gridOptions.columns,arg.sender);
        }


        /*		function updateAggregates(arg){
                    if(exists(parentField)){
                        var aggregates = arg.sender.dataSource.aggregates();
                        var natureOfAggregate= arg.sender.dataSource.aggregate();
                        function updateAggregate(fieldName){
                            var field = parentField.gridOptions.columns.filter(function(field){return field.name==fieldName});
                            if(field.length>0){
                                field=field[0];
                            }
                            else{
                                return;
                            }
                            var aggregateType=natureOfAggregate.filter(function(item){return item.field=="AverageClassFee"})[0]["aggregate"];
                            field.value=aggregates[fieldName][aggregateType];
                        }
                        Object.keys(aggregates).forEach(updateAggregate);
                    }
                }*/
        return mainGridOptions;
    }


    function setDefaultIdToModel(model) {
        var id = model.id;
        model.fields[id].defaultValue = function () {
            return Math.ceil((Math.random() * 100000)) * -1;
        }
    }

    function setDefaultForDropdown(key, model) {
        if (!exists(model[key].type)) {
            model[key].defaultValue = function () {
                return null;
            }
        }


        else if(exists(model[key].type) && model[key].type=="date"){
            if(['createddate','lastupdateddate'].includes(key.toLowerCase())){ // dont set default values for these keys
                return;
            }
            model[key].defaultValue = function () {
                if(model[key].default_value && model[key].default_value=="now")
                    return new Date();
                else
                    return '';
            }
        }
        else if(exists(model[key].type) && model[key].type=="number"){
            return 0;
        }
    }

})();